<wiz-vgroup width="100%" height="100%" gap="2" class="section-container">
  <!-- filtre de la popUp -->
  <filter-component #popFilter width="100%"> </filter-component>

  <wiz-ag-grid
  #agGrid
  [gridOptions]="gridOptions"
  width="100%"
  height="100%"
  class="ag-theme-alpine"
  [wizDatasource]="dataDS"
  wizRowSelection="single"
  [columnDefs]="keyGridColumns"></wiz-ag-grid>

  <wiz-hgroup width="100%" horizontalAlign="space-between">
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'arrow-left'"
      (wizClick)="doCancel()"
      [wizLabel]="'$.common.cancel.$'"
    ></wiz-button>
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.ok.$'"
      [wizIcon]="'arrow-right'"
      [iconPlacement]="'right'"
      (wizClick)="save()"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
